import { render, staticRenderFns } from "./ProductCombosTable.vue?vue&type=template&id=7cad9fe8&"
import script from "./ProductCombosTable.vue?vue&type=script&lang=ts&"
export * from "./ProductCombosTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports